import React from "react";
import { useTranslation } from "react-i18next";
import Active_Logo_White from "../img/active_logo_white.png";
import logo from "../img/logoff.png";

export const PoweredBy = () => {
  const { t } = useTranslation();

  return (
    <div className="main-page-powered-by-conatiner">
      <div className="main-page-powered-by-text-container">
        <p style={{ marginRight: "3px" }}>{t("POWERED_BY")}</p>
        <img src={logo} style={{ height: "18px" }} />
      </div>

      <div className="powered-by-logo-container">
        <img src={Active_Logo_White} style={{ height: "12px" }} />
        <p style={{ marginLeft: "5px" }}>{t("CLALIT")}</p>
      </div>
    </div>
  );
};
